import { BASE_URL } from '@/config'

export async function createQuestion(questionData) {
  try {
    const response = await fetch(`${BASE_URL}/quest/question`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(questionData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao criar pergunta')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao criar pergunta:', error)
    throw error
  }
}

export async function getQuestions() {
  try {
    const response = await fetch(`${BASE_URL}/quest/question`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar perguntas')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar perguntas:', error)
    throw error
  }
}

export async function updateQuestion(id, questionData) {
  if (!id) {
    throw new Error('O ID da pergunta é obrigatório para atualização.')
  }

  try {
    const response = await fetch(`${BASE_URL}/quest/updater/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(questionData),
    })
    console.log('Response:', response)

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao atualizar pergunta')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao atualizar pergunta:', error)
    throw error
  }
}

export async function deleteQuestion(id) {
  if (!id) {
    throw new Error('O ID da pergunta é obrigatório para exclusão.')
  }

  try {
    const response = await fetch(`${BASE_URL}/quest/delete/${id}`, {
      method: 'DELETE',
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao excluir pergunta')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao excluir pergunta:', error)
    throw error
  }
}

export async function getQuestionsByControllerId(id) {
  if (!id) {
    throw new Error('O ID do controlador é obrigatório para exclusão.')
  }

  try {
    const response = await fetch(`${BASE_URL}/quest/controller/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar perguntas')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar perguntas:', error)
    throw error
  }
}

export async function getQuestionById(id) {
  try {
    const response = await fetch(`${BASE_URL}/quest/question/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar pergunta por ID')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar pergunta por ID:', error)
    throw error
  }
}

export async function getQuestionByEmployeeId(id) {
  try {
    const response = await fetch(`${BASE_URL}/quest/employee/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar perguntas por ID do funcion√°rio'
      )
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar perguntas por ID do funcion√°rio:', error)
    throw error
  }
}

export async function assignQuestion(id, questionData) {
  if (!id) {
    throw new Error('ID da pergunta é obrigatório')
  }

  if (!questionData || !questionData.action) {
    throw new Error(
      'A ação (add/remove) é obrigatória para modificar a pergunta'
    )
  }
  try {
    const response = await fetch(`${BASE_URL}/quest/updater/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(questionData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao modificar a pergunta')
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao modificar a pergunta:', error)
    throw error
  }
}

// Verifica se a questão existe para o funcionário

export async function verifyEmployeeQuestion(ControllerID, EmployeesID) {
  try {
    const response = await fetch(`${BASE_URL}/quest/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ControllerID, EmployeesID }),
    })
    if (!response.ok) {
      throw new Error('Erro ao verificar a questão')
    }
    return await response.json()
  } catch (error) {
    console.error('Erro ao verificar a questão:', error)
    throw error
  }
}
